"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Languages = void 0;
const runtypes_1 = require("runtypes");
exports.Languages = (0, runtypes_1.Union)((0, runtypes_1.Literal)("java"), (0, runtypes_1.Literal)("kotlin"));
//# sourceMappingURL=languages.js.map